// Headless export registration for Rapid Association (`sft`). RapidAssociationChart
// renders through ChartContainer (Phase 2 hook covers it). viewMode picks the render:
// 'bar' (answer keyed a{position}) / 'stacked' (calcStackedHcAnswers) / else scatter.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/03-highcharts-rollout.md §4.2

import { commonHcProps, registerHc } from '@aytm/app/stats/page/question-views/components/charts/lib/hc-exportable'

import RapidAssociationChart from '@aytm/app/stats/page/question-views/sft/components/chart/Chart'

registerHc(['sft'], RapidAssociationChart, (data: any, params: any) => ({
  ...commonHcProps(data, params),
  // view-selection → params
  viewMode: params.viewMode,
  // question data/config → data
  btnsType: data.btnsType,
  answerVariants: data.answerVariants,
  rType: data.rType
}))
